import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export default function SsoLogin() {
  const { token: tokenFromPath } = useParams();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromQuery = params.get('token');
    const tokenFromPathname = decodeURIComponent((location.pathname.split('/sso/')[1] || '')).trim();
    const rawToken = decodeURIComponent(tokenFromPath || tokenFromQuery || tokenFromPathname || '').trim();

    // Tolère les deux formats de retour: "<jwt>" ou "JWT <jwt>"
    const normalizedToken = rawToken.startsWith('JWT ')
      ? rawToken.slice(4).trim()
      : rawToken;

    // Vérification légère du format JWT avant stockage.
    const looksLikeJwt = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(normalizedToken);
    if (!looksLikeJwt) {
      localStorage.removeItem('token');
      history.replace('/login?password=1&ssoError=invalid_token');
      return;
    }

    // L'API renvoie le JWT "nu" dans l'URL (/sso/<token>), on garde le même format
    // que le login classique pour les appels API (Authorization: "JWT <token>").
    localStorage.setItem('token', `JWT ${normalizedToken}`);
    sessionStorage.removeItem('octadmin_sso_attempted');
    // Réinitialiser l'état auth côté store, le router rechargera /profile
    dispatch({ type: 'ERROR_AUTH', payload: null });
    history.replace('/');
  }, [tokenFromPath, location.pathname, location.search, history, dispatch]);

  return null;
}
